import { Autocomplete, Box, Grid } from "@mui/material"
import { CstmTextField } from "../../../../../core/global/forms/CstmTextField"
import { Generate } from "./Generate"
import { useContext } from "react"
import { ToolContext } from "../../../../../core/context/ToolContext"

export const Thead = ({inputChangeHandler, branchData, branchProductData, snackBarLoader}) => {
    const {tool_state, report_state} =useContext(ToolContext)
    const {__SESSION} = tool_state
    const {comProductIds, generateForm, salesProductData, salesProductList, form} = report_state


    return (
        <Box minHeight="170px" display="flex" flexDirection="column" justifyContent="center" gap={1.5}>
            <Box width="100%" display="flex" alignItems="center" gap={3} bgcolor="#FFFFFF" borderRadius="12px" p={2}>
                <Box width="100%" id="walkthrough-branch-product-report-step-1">
                    <Autocomplete   
                        fullWidth
                        options={branchData.data}
                        getOptionLabel={(option) => option.name}
                        onChange={(e, value) => inputChangeHandler(e, value, 'branch_id')}
                        value={ form.data.branch_id === '' ? null : branchData.data.find((f) => f.company_branch_id === form.data.branch_id) || null} 
                        renderInput={(params) => (
                            <CstmTextField {...params} label="Branch" placeholder="Branch" />
                        )}
                    />
                </Box>
                <Box width="100%" id="walkthrough-branch-product-report-step-2">
                    <Autocomplete
                        fullWidth
                        options={branchProductData || []} 
                        getOptionLabel={(option) => {
                            if (!option) return ''; 
                            const alias = option.alias || '';
                            const subCat = option.sub_cat_name || '';
                            const product = option.product_name || '';
                            return alias.trim() === '' ? `${subCat} ${product}` : alias;
                        }}
                        isOptionEqualToValue={(option, value) => option.id === value.id} 
                        onChange={(e, value) => inputChangeHandler(e, value, 'product_id')}
                        value={
                            form.data.product_id === ''
                                ? null
                                : branchProductData.find((f) => f.id === form.data.product_id) || null
                        }
                        renderOption={(props, option) => (
                            <li {...props} key={option.id}>
                                {option.alias?.trim() === '' || option.alias === null
                                    ? `${option.sub_cat_name || ''} ${option.product_name || ''}`
                                    : option.alias}
                            </li>
                        )}
                        renderInput={(params) => (
                            <CstmTextField {...params} label="Product" placeholder="Product" />
                        )}
                    />
                </Box>
                <CstmTextField id="walkthrough-branch-product-report-step-3" fullWidth type="date" variant="outlined" label="Date From" name="from" InputLabelProps={{shrink: true}} 
                InputProps={{ inputProps: { max:"9999-12-31"}}} onInput={(e) => inputChangeHandler(e)} value={form.data.from} error={snackBarLoader.data && form.data.from === ''}/>
                <CstmTextField  id ="walkthrough-branch-product-report-step-4" fullWidth type="date" variant="outlined" label="Date To" name="to" InputLabelProps={{shrink: true}} InputProps={{inputProps: {min: form.data.from, max:"9999-12-31"}}} onInput={(e) => inputChangeHandler(e)} value={form.data.to} error={((snackBarLoader.data && form.data.to === '') || (form.data.to < form.data.from))}/>
                <Generate __SESSION={__SESSION} snackBarLoader={snackBarLoader} form={form.data} comProductIds={comProductIds} generateForm={generateForm.data} setGenerateForm={generateForm.set} salesProductData={salesProductData.data} setSalesProductData={salesProductData.set} salesProductList={salesProductList.data} />
            </Box>
            <Grid container direction="row" sx={{py:2, px:4, bgcolor:'#EBEBEB', borderRadius:'10px'}}>
                <Grid item xs={2.5}>Branch</Grid>
                <Grid item xs={3}>Product</Grid>
                <Grid item xs={2.5} textAlign="center">Date&Time</Grid>
                <Grid item xs={2} textAlign="center">Qty Sold</Grid>
                <Grid item xs={2} textAlign="center">Total Sale</Grid>
            </Grid>
        </Box>
    )
}